import * as React from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { useState, useEffect } from 'react';
import { config } from '@uhg-abyss/web/tools/config';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { Button } from '@uhg-abyss/web/ui/Button';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Brandmark } from '@uhg-abyss/web/ui/Brandmark';
import { Avatar } from '@uhg-abyss/web/ui/Avatar';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Box } from '@uhg-abyss/web/ui/Box';
import { DropdownMenu } from '@uhg-abyss/web/ui/DropdownMenu';
import { Text } from '@uhg-abyss/web/ui/Text';
import { useAuth } from '@src/common/auth/AuthProvider';

export default function Navbar() {
  const { user } = useAuth();
  const { navigate } = useRouter();
  const [isOpen, setIsOpen] = useState(false);

  const appEnv = (config('APP_ENV') || '').toLowerCase();
  const isProdEnv = appEnv === 'prod';

  // Check if current route is logout page
  const currentPath = location?.pathname;
  const isLogoutPage = currentPath === '/logout';

  const [username, setUsername] = useState('');
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    if (user) {
      setUsername(user.displayName || '');
      setUserEmail(user.mail || '');
    }
  }, [user]);

  const handleLogout = () => {
    sessionStorage.clear();
    setIsAuthorized(false);
    navigate('/logout');
  };

  const handleSelectText = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const selection = window.getSelection();
    if (!selection) return;
    const range = document.createRange();
    range.selectNodeContents(event.target);
    selection.removeAllRanges();
    selection.addRange(range);
  };

  const formattedUsername = username
    .split(' ')
    .map((email) => email)
    .reverse()
    .join(' ')
    .replace(',', '');

  const menuItems = [
    {
      title: (
        <Text
          fontWeight={500}
          style={{ userSelect: 'text', cursor: 'default' }}
          onClick={handleSelectText}
        >
          {formattedUsername}
        </Text>
      ),
      onClick: () => {},
      icon: <IconSymbol icon="account_circle" />,
    },
    {
      title: (
        <Text
          fontWeight={500}
          style={{ userSelect: 'text', cursor: 'default' }}
          onClick={handleSelectText}
        >
          {userEmail}
        </Text>
      ),
      onClick: () => {},
      icon: <IconSymbol icon="stacked_email" />,
      // isSeparated: true,
    },
    // {
    //   title: <Text fontWeight={500}>Logout</Text>,
    //   onClick: () => {
    //     handleLogout();
    //   },
    //   icon: <IconSymbol icon="logout" />,
    // },
  ];

  return (
    <>
      <React.Fragment>
        <Grid
          style={{
            margin: 0,
            overflow: 'hidden',
          }}
        >
          <Grid.Col
            span={{ xs: '100%' }}
            style={{
              padding: 0,
            }}
          >
            <Box color="$web.semantic.color.surface.container.primary" padding="5px">
              <Grid
                justify="space-between"
                align="center"
                css={{ flexWrap: 'nowrap' }}
              >
                {/* Nav Menu + Logo  */}
                <Grid.Col css={{ flex: '1 1 auto', minWidth: 0 }}>
                  <Grid css={{ flexWrap: 'nowrap' }}>
                    {/* Logo */}
                    <Grid.Col css={{ flex: '0 1 auto', minWidth: 0 }}>  
                      <Box
                        color="$web.semantic.color.surface.container.primary"
                        style={{
                          width: '250px',
                          '@screen < $sm': { width: '150px' },
                        }}
                        padding="15px 0px 0px 0px"
                      >
                        <Brandmark
                          brand="uhg"
                          title="UnitedHealth Group"
                          affiliate="uhg"
                          variant="lockup"
                          color="white"
                          size={250}
                          onClick={() => navigate('/')}
                          style={{ cursor: 'pointer' }}
                        />
                      
                      </Box>
                    </Grid.Col>
                  </Grid>
                </Grid.Col>

                {/* Project Title - Center */}
                <Grid.Col css={{ flex: '1 0 auto', textAlign: 'center' }}>
                  <Text
                    size="xl"
                    fontWeight={600}
                    color="$white"
                    style={{ whiteSpace: 'nowrap', color: 'white', marginRight: '100%', marginLeft: '-10%', fontSize: '25px'}}
                  >
                    Medical Record Scanning Tool
                    {!isProdEnv && (
                      <strong><span style={{ color: '#ffff00' }}> - Test</span></strong>
                    )}
                  </Text>
                </Grid.Col>

                <Grid.Col css={{ flex: '0 0 auto' }}>
                  <Grid css={{ flexWrap: 'nowrap' }}>
                    {user && username && !isLogoutPage ? (
                      <Grid.Col>
                        <DropdownMenu
                          hideLabel
                          variant="filled"
                          role="button"
                          menuItems={menuItems}
                          css={{
                            cursor: 'pointer',
                          }}
                          before={
                            <Avatar
                              title={username
                                .split(' ')
                                .map(
                                  (element) =>
                                    element[0] +
                                    element.slice(
                                      1,
                                      element.replace(',', '').length
                                    )
                                )
                                .reverse()
                                .join(' ')}
                              style={{
                                cursor: 'pointer',
                              }}
                            >
                              {username
                                .split(' ')
                                .map((name) => name[0])
                                .reverse()
                                .join('')}
                            </Avatar>
                          }
                          width={150}
                        />
                      </Grid.Col>
                    ) : (
                      <Grid.Col style={{ position: 'relative', right: 10 }}>
                        <Avatar src={null}>
                          <IconSymbol icon="account_circle" />
                        </Avatar>
                      </Grid.Col>
                    )}
                  </Grid>
                </Grid.Col>
              </Grid>
            </Box>
          </Grid.Col>
        </Grid>
      </React.Fragment>
      <Router.Outlet />
    </>
  );
}
